import React, { Component } from "react";
class CheckboxHolder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false
    };
    this.handlePress = this.handlePress.bind(this);
  }
  handlePress() {
    this.setState(currentState => {
      return {
        menuOpen: !currentState.menuOpen
      };
    });
  }

  render() {
    return (
      <div onClick={this.handlePress} className="checkbox-holder">
        {this.props.children}
      </div>
    );
  }
}

export default CheckboxHolder;



// WEBPACK FOOTER //
// ./src/components/CheckboxHolder.js